import { render, staticRenderFns } from "./CampaignStepReview.vue?vue&type=template&id=10f92eab&scoped=true"
import script from "./CampaignStepReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignStepReview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignStepReview.vue?vue&type=style&index=0&id=10f92eab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f92eab",
  null
  
)

export default component.exports